import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { LicenseServerRoutingModule } from "./license-server-routing.module";
import { LicenseServerListComponent } from "./components/license-server-list/license-server-list.component";
import { LicenseServerLeftPanelComponent } from "./components/license-server-left-panel/license-server-left-panel.component";
import { LicenseServerMainPanelComponent } from "./components/license-server-main-panel/license-server-main-panel.component";
import { AddLicenseServerComponent } from "./modals/add-license-server/add-license-server.component";
import { UpdateLicenseServerComponent } from "./modals/update-license-server/update-license-server.component";
import { DeleteLicenseServerComponent } from "./modals/delete-license-server/delete-license-server.component";
import { NgxPaginationModule } from "ngx-pagination";
import { NgxSpinnerModule } from "ngx-spinner";
import { AngularMaterialModule } from "src/app/shared/material-module";
import { LicenseParentListComponent } from "./components/license-parent-list/license-parent-list.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CoreModule } from "src/app/core/core.module";
import { ResizableModule } from "../../core/directive/resizable/resizable.module";
import { SharedModule } from "../shared/shared.module";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { NgSelectModule } from "@ng-select/ng-select";
import { DynamicPaginationDirective } from "src/app/core/directive/dynamicPagination/dynamic-pagination.directive";
import { NgMultiSelectDropDownModule } from "ng-multiselect-dropdown";
import { LicenseSummaryViewComponent } from "./components/license-summary-view/license-summary-view.component";

@NgModule({
  declarations: [
    LicenseServerListComponent,
    LicenseServerLeftPanelComponent,
    LicenseServerMainPanelComponent,
    AddLicenseServerComponent,
    UpdateLicenseServerComponent,
    DeleteLicenseServerComponent,
    LicenseParentListComponent,
    LicenseSummaryViewComponent
  ],
  imports: [
    CommonModule,
    LicenseServerRoutingModule,
    NgxSpinnerModule,
    NgxPaginationModule,
    AngularMaterialModule,
    ReactiveFormsModule,
    FormsModule,
    CoreModule,
    SharedModule,
    ResizableModule,
    NgbModule,
    NgSelectModule,
    SharedModule,
    DynamicPaginationDirective,
    NgMultiSelectDropDownModule,
  ],
})
export class LicenseServerModule {}
